import * as constants from './occupier-types'
import instance from '../../../services/instance'

export default {
  [constants.GET_OCCUPIERS_FULL_LIST] ({ commit, rootState }, params = null) {
    let url = params ? `/occupier/list?${params}` : '/occupier/list'
    return new Promise((resolve, reject) => {
      instance
        .get(url, {
          headers: {
            Authorization: 'Bearer ' + rootState.idToken,
          },
        })
        .then((res) => {
          let { result } = res.data
          // commit(constants.SET_OCCUPIERS_FULL_LIST, result)
          resolve(result)
        })
        .catch((err) => {
          reject(new Error(err))
        })
    })
  },
}
